import { createAction, props } from '@ngrx/store';
import { StoreConstants } from '../constants/store-constants';

export const pageLoadingStart = createAction(
  `[${StoreConstants.STORE_KEY}] page Loading started`,
  props<{ description: string }>(),
);

export const pageLoadingFinish = createAction(`[${StoreConstants.STORE_KEY}] page Loading complete`);
